"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _FullscreenModalLayout = require("./FullscreenModalLayout");
Object.keys(_FullscreenModalLayout).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FullscreenModalLayout[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _FullscreenModalLayout[key];
    }
  });
});